import { AxiosInstance } from 'axios';

export interface PostDTO {
  id: string;
  title: string;
  content: string;
  category: 'question' | 'parent' | 'teacher' | 'case' | 'job' | 'general';
  authorId: string;
  viewCount: number;
  likeCount: number;
  commentCount: number;
  isPinned: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  author?: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    displayName?: string;
    avatarUrl?: string;
    userType?: string;
  };
  comments?: Array<{
    id: string;
    postId: string;
    authorId: string;
    content: string;
    parentId?: string;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    author?: {
      id: string;
      username: string;
      firstName: string;
      lastName: string;
      displayName?: string;
      avatarUrl?: string;
    };
    replies?: Array<{
      id: string;
      postId: string;
      authorId: string;
      content: string;
      parentId?: string;
      isDeleted: boolean;
      createdAt: string;
      updatedAt: string;
      author?: {
        id: string;
        username: string;
        firstName: string;
        lastName: string;
        displayName?: string;
        avatarUrl?: string;
      };
    }>;
  }>;
}

export interface PostListResponse {
  success: boolean;
  data: {
    posts: PostDTO[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface PostDetailResponse {
  success: boolean;
  data: PostDTO;
}

export interface CreatePostParams {
  title: string;
  content: string;
  category: string;
}

export interface UpdatePostParams {
  title?: string;
  content?: string;
}

export interface GetPostListParams {
  category?: string;
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: 'latest' | 'popular' | 'comments';
}

export default class PostService {
  constructor(private axios: AxiosInstance) {}

  // 게시글 목록 조회 (Public)
  getPostList = async (params?: GetPostListParams): Promise<PostListResponse> => {
    const { data } = await this.axios.get('/post', { params });
    return data;
  };

  // 게시글 상세 조회 (Public)
  getPostById = async (id: string): Promise<PostDetailResponse> => {
    const { data } = await this.axios.get(`/post/${id}`);
    return data;
  };

  // 게시글 작성 (Auth Required)
  createPost = async (params: CreatePostParams): Promise<PostDetailResponse> => {
    const { data } = await this.axios.post('/post', params);
    return data;
  };

  // 게시글 수정 (Auth Required)
  updatePost = async (id: string, params: UpdatePostParams): Promise<PostDetailResponse> => {
    const { data } = await this.axios.put(`/post/${id}`, params);
    return data;
  };

  // 게시글 삭제 (Auth Required)
  deletePost = async (id: string): Promise<{ success: boolean; message: string }> => {
    const { data } = await this.axios.delete(`/post/${id}`);
    return data;
  };
}

